import { memo } from 'react';

import { Box, Icon } from '@zillow/constellation-10';
import { IconPhotosFilled } from '@zillow/constellation-icons';

import { BigDropzone, SmallDropzone } from '@zg-rentals/maintenance-utils';

import { useScreenSize } from '../../hooks/useScreenSize';

import { containerRecipe } from './styles';

import type { ReactNode } from 'react';
import type { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';

type Props = {
  isSmallDropzone?: boolean;
  isDisabled?: boolean;
  isEmpty?: boolean;
  rootProps: DropzoneRootProps;
  inputProps: DropzoneInputProps;
  displayText?: string;
  /** Compact-tile label; `displayText` stays desktop-only so other dropzones keep showing "Add" on mobile. */
  smallDisplayText?: string;
  IconToDisplay?: ReactNode;
};

const UploadDropzone = ({
  isSmallDropzone = false,
  isDisabled = false,
  isEmpty = false,
  rootProps,
  inputProps,
  displayText = '',
  smallDisplayText,
  IconToDisplay = <IconPhotosFilled />,
}: Props) => {
  const { isScreenMobile } = useScreenSize();

  const { isDragAccept, isDragReject } = rootProps;

  const isContainerSizeFixed = (isScreenMobile || isSmallDropzone) && isEmpty;

  return (
    <Box
      css={containerRecipe.raw({
        isContainerSizeFixed,
        isSmallDropzone,
        isDisabled,
        isDragReject,
        isDragAccept,
      })}
      {...rootProps}
    >
      <input {...inputProps} />

      <Icon render={IconToDisplay} size="lg" css={{ color: isDragAccept ? 'icon.accent.brand.hero' : undefined }} />
      {isScreenMobile || isSmallDropzone ? (
        <SmallDropzone displayText={smallDisplayText} />
      ) : (
        <BigDropzone displayText={displayText} disabled={isDisabled} />
      )}
    </Box>
  );
};

export default memo(UploadDropzone);
